export const NumberCell = (value: string)=> {
  const valueAsNumber = value === null ? '' : +value
  return valueAsNumber.toLocaleString("en-US")
}
